import React, { useEffect, useState } from "react";
import { onSnapshot, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { docAt } from "./fbPath";
import { toast } from "react-toastify"; // ✅ toast
import "./css/Bookmark.css"; // NEW: separate CSS

export default function BookmarkButton({ bookmarkKey, className = "" }) {
  // bookmarkKey: stable string like "missions:abc" or "vehicles_weapons:car42"
  const auth = getAuth();
  const user = auth.currentUser;
  const [bookmarked, setBookmarked] = useState(false);

  useEffect(() => {
    if (!user || !bookmarkKey) { setBookmarked(false); return; }
    return onSnapshot(
      docAt("users", user.uid, "bookmarks", bookmarkKey),
      (s) => setBookmarked(s.exists())
    );
  }, [bookmarkKey, user?.uid]);

const toggle = async () => {
  if (!user) {
    toast.info("Please login to bookmark");
    return;
  }
  try {
    const ref = docAt("users", user.uid, "bookmarks", bookmarkKey);
    if (bookmarked) {
      await deleteDoc(ref);
      toast.success("Removed bookmark");
    } else {
      await setDoc(ref, { createdAt: serverTimestamp() });
      toast.success("Bookmarked");
    }
  } catch (e) {
    console.error("Bookmark error:", e);   // ✅ log full error to console
    toast.error("Could not update bookmark");
  }
};


  const loggedOut = !user;

  return (
    <button
      type="button"
      className={`msn-action bookmark-btn ${className} ${loggedOut ? "is-disabled" : ""}`}
      onClick={toggle}                          // keep clickable for toast
      aria-pressed={bookmarked}
      aria-disabled={loggedOut}                 // a11y hint only
      title={loggedOut ? "Please login to bookmark" : (bookmarked ? "Remove bookmark" : "Add bookmark")}
      onKeyDown={(e) => {
        if ((e.key === "Enter" || e.key === " ") && !e.shiftKey) {
          e.preventDefault();
          toggle();
        }
      }}
    >
      {bookmarked ? "🔖 Bookmarked" : "🔖 Bookmark"}
    </button>
  );
}
